















import Component from 'vue-class-component'
import Vue from 'vue'
import UnifyButton from '@/shared/components/unify/unify-button.vue'
import { ResourceVariant } from '@/api/generated'
import ResourceDialog from '@/shared/components/resource-dialog/resource-dialog.vue'
import { Inject, Prop } from 'vue-property-decorator'
import { FormGroup } from '@/shared/forms/form-group'
import { DialogService } from '@/shared/dialog/dialog-service'
import { Injector } from '@/config/dependency-injection'
import { ResourceDialogInput } from '@/shared/components/resource-dialog/resource-dialog-input'
import { ResourceDialogOutput } from '@/shared/components/resource-dialog/resource-dialog-output'
import RespondecoResponsiveImage from '@/shared/components/respondeco-responsive-image.vue'

@Component({
  name: 'respondeco-resource-chooser',
  components: { RespondecoResponsiveImage, UnifyButton },
})
export default class RespondecoResourceChooser extends Vue {
  @Prop({
    type: Number,
  })
  public readonly aspectRatio?: number

  @Prop({
    type: String,
  })
  public readonly control!: string

  @Prop({
    type: String,
  })
  public readonly title!: string

  @Inject()
  private readonly form!: FormGroup<any>

  private dialogService = Injector.get(DialogService)

  get resource() {
    return this.form.validations[this.control].$model
  }

  set resource(value: ResourceVariant) {
    this.form.validations[this.control].$model = value
  }

  public openResourceDialog(): void {
    this.dialogService
      .openDynamic<ResourceDialogInput, ResourceDialogOutput>(ResourceDialog, {
        allowedType: 'image',
        aspectRatio: this.aspectRatio,
        title: this.title,
      })
      .submitted(resource => {
        // Since we allow only image the given resource can only be a resource variant
        this.resource = resource as ResourceVariant
      })
  }
}
